/**
 * Handles all tooltip interaction
 * @param {Microsoft.Maps.Map} map
 * @param {Object} options  a set of key/value pairs that configure the tooltip
 * 
 *     REQUIRED
 *       hoverTemplate {jQuery} the hover tooltip
 *       clickTemplate {jQuery} the click tooltip
 *       getHoverHtml {Function} a jQuery promise callback with HTML content
 *       getClickHtml {Function} a jQuery promise callback with HTML content
 * 
 *     OPTIONAL
 *       hoverOffset {Object} x, y offset from pushpin. Defaults to 0, 0
 *       clickOffset {Object} x, y offset from pushpin. Defaults to 0, 0
 *       initClickTooltip {Function}  a callback after the click tooltip html is replaced
 *       initHoverTooltip {Function}  a callback after the hover tooltip html is replaced
 * 
 */
define(['jquery'], function ($) {
   "use strict";

   return function (map, options) {
      var self = this,
         BingMaps = window.Microsoft.Maps,

         m_map = map,

         m_options = $.extend({
            hoverOffset: {
               x: 0,
               y: 0,
               tip: 0
            },

            clickOffset: {
               x: 0,
               y: 0,
               tip: 0
            },

            initClickTooltip: function () {},
            initHoverTooltip: function () {},

            onShowTooltip: function (pinData) {},
            onHideTooltip: function (pinData) {},
            onShowClickTooltip: function (pinData) {},
            onHideClickTooltip: function (pinData) {},
            onShowHoverTooltip: function (pinData) {},
            onHideHoverTooltip: function (pinData) {}
         }, options),

         m_hoverPin,
         m_clickPin,

         m_bHoverHidden = true,
         m_bClickHidden = true,

         m_clickDeferred = $.Deferred(),
         m_hoverDeferred = $.Deferred(),

         m_jHoverTemplate = m_options.hoverTemplate,
         m_jClickTemplate = m_options.clickTemplate,

         m_hoverValid,
         m_jMapContainer,

         getMapContainer = function () {
            if (!m_jMapContainer) {
               m_jMapContainer = $("#mapContainer");
            }

            return m_jMapContainer;
         },

         /**
          * Update the position of the tooltip to match the pin
          * @param {Century21.Map.PinData}  pinData
          * @param {jQuery}                 jTemplate  the tooltip template
          * @param {Object}                 offset     an object containing x, y offset for the tooltip (in relation to the pushpin)
          * @return {Object} the x, y coordinates for the tooltip
          */
         updatePosition = function (pinData, jTemplate, offset, hide) {
            var pix = m_map.tryLocationToPixel(pinData.getLocation(), BingMaps.PixelReference.control);

            // If Bing failed to get a coordinate from the location
            if (!pix) {
               // Hide the tooltip
               jTemplate.hide();

               // Do not continue
               return false;
            }

            // The tooltip will start in the upper-lefthand corner of the PAGE (not the MAP)
            var iWidth = jTemplate.outerWidth(),
               jMapContainer = getMapContainer(),
               offsetMap = jMapContainer.offset(),
               iMapX = offsetMap.left,
               iMapY = offsetMap.top,
               iWindowWidth = $(window).width(),
               iLeft = pix.x - (iWidth / 2) + offset.x + iMapX,
               iTop = pix.y - jTemplate.outerHeight() + offset.y + iMapY,
               jTip = jTemplate.find(".contentTip");

            if (pix.y < 0 || pix.x < 0 || pix.x > jMapContainer.width() || pix.y > jMapContainer.height()) {
               hide();
            }

            if (pix.x + iMapX + (iWidth / 2) + 16 >= iWindowWidth) {
               jTemplate.css({
                  left: 'auto',
                  top: iTop,
                  right: 0
               });
               jTip.css({
                  left: iWidth - (iWindowWidth - (pix.x + iMapX)) - offset.tip
               });
            } else {
               jTemplate.css({
                  right: 'auto',
                  left: iLeft,
                  top: iTop
               });
               jTip.css({
                  left: "50%"
               });
            }

            return {
               x: iLeft,
               y: iTop
            };
         },

         removeCardHover = function () {
            if (m_hoverPin) {
               m_hoverPin.getCard().removeClass('cardHover');
            }
         },

         rejectClick = function () {
            if (m_clickDeferred.state() !== "resolved") {
               m_clickDeferred.reject();
            }
         },

         hideClickTooltip = function () {
            // Cancel any in-progress calls
            rejectClick();

            m_bClickHidden = true;
            m_map.clickHidden = true;

            if (m_jClickTemplate !== undefined) {
               m_jClickTemplate.hide();
            }

            m_options.onHideTooltip(m_clickPin);
            m_options.onHideClickTooltip(m_clickPin);
         },

         updateClickPosition = function () {
            if (!m_clickPin) {
               return;
            }

            return updatePosition(m_clickPin, m_jClickTemplate, m_options.clickOffset, hideClickTooltip);
         },

         updateHoverPosition = function () {
            if (!m_hoverPin) {
               return;
            }

            return updatePosition(m_hoverPin, m_jHoverTemplate, m_options.hoverOffset, self.hideHoverTooltip);
         },

         rejectHover = function () {
            if (m_hoverDeferred.state() !== "resolved") {
               m_hoverDeferred.reject();
               m_hoverValid = false;
            }
         },

         showClick = function (pinData) {
            // Call any initialization JS for the tooltip
            m_options.initClickTooltip(m_jClickTemplate, pinData);

            // Reset the cover
            m_jClickTemplate.find('.hoverCover').stop(true).show().css({
               opacity: 1
               // Fade out the cover
            }).animate({
               opacity: 0
            }, 500, function () {
               m_jClickTemplate.find('.hoverCover').hide();
            });

            if (pinData === m_hoverPin) {
               self.hideHoverTooltip();
            }

            m_options.onShowTooltip(m_clickPin);
            m_options.onShowClickTooltip(m_clickPin);
         },

         showHover = function (bAnimateMoveUp, bShowCover, bAnimateUnfadeCover, bRepositionX) {
            var pix;

            if (bRepositionX) {
               // Hover tooltips have a dynamic width
               // There is a good chance the hover tooltip is currently
               // in an active animation at this point (if the content
               // has loaded before the animation finished)

               // Save the current 'top' attribute (which is being animated)
               var strTop = m_jHoverTemplate.css('top');

               // Update the position of the tooltip to match the
               // position of the pin
               pix = updateHoverPosition();

               // Change the 'top' attribute back
               m_jHoverTemplate.css('top', strTop).stop().animate({
                  top: pix.y
               });
            }

            if (bAnimateMoveUp) {
               pix = updateHoverPosition();

               m_jHoverTemplate.stop(true).show();

               // Reposition after shown to handle dynamic width elements
               pix = updateHoverPosition();

               // This is possible
               if (!pix) {
                  return;
               }

               m_jHoverTemplate.css({
                  top: pix.y + 10
               }).animate({
                  top: pix.y
               }, 500);
            }

            if (bShowCover) {
               m_jHoverTemplate.find('.hoverCover').show().css({
                  opacity: 1
               });
            }

            if (bAnimateUnfadeCover) {
               m_jHoverTemplate.find('.hoverCover').animate({
                  opacity: 0
               }, 500, function () {
                  m_jHoverTemplate.find('.hoverCover').hide();
               });

               m_options.onShowTooltip(m_hoverPin);
               m_options.onShowHoverTooltip(m_hoverPin);
            }
         },

         initialize = function () {
            var el = m_map.getRootElement().parentNode;

            $(el).append(m_jHoverTemplate).append(m_jClickTemplate);

            BingMaps.Events.addHandler(m_map, 'viewchange', function () {
               updateClickPosition();
               updateHoverPosition();
            });
         };

      self.showClickTooltip = function (pinData) {
         // Cancel in-progress calls
         rejectClick();

         // Update the currently showing pin
         m_clickPin = pinData;
         m_bClickHidden = false;
         m_map.clickHidden = false;

         // Show the click tooltip
         m_jClickTemplate.show()
            // And reset the cover
            .find('.hoverCover').stop(true).show().css({
               opacity: 1
            });

         // Move the click tooltip to the correct location
         updateClickPosition();

         self.hideHoverTooltip();

         // Create a new deferred request
         m_clickDeferred = $.Deferred();

         // Fetch the html for the click tooltip
         m_options.getClickHtml(pinData).then(m_clickDeferred.resolve);

         // When the deferred object succeeds
         m_clickDeferred.then(function (strHtml) {
            // Show the click template!!
            m_jClickTemplate.html(strHtml);
            showClick(pinData);
            updateClickPosition();
         });
      };

      self.hideTooltipByPinData = function (pinData) {
         if ((m_clickPin === pinData) && (!m_bClickHidden)) {
            hideClickTooltip();
         }

         if ((m_hoverPin === pinData) && (!m_bHoverHidden)) {
            self.hideHoverTooltip();
         }
      };

      self.showHoverTooltip = function (pinData) {
         // If the click state is showing
         if (!m_map.clickHidden) {
            // Do not continue
            return;
         }

         removeCardHover();
         pinData.getCard().addClass('cardHover');

         // Do not show if the coordinates are missing
         if (pinData.Latitude === undefined) {
            m_hoverPin = pinData;
            return;
         }

         // If this is the same as the click pin
         if (pinData === m_clickPin) {
            // And the click pin is showing
            if (!m_bClickHidden) {
               // Why bother showing the hover tooltip?
               return;
            }
         }

         // If this is the same pin as last time
         if ((m_hoverValid) && (pinData === m_hoverPin)) {
            // And the pin is not hidden
            if (!m_bHoverHidden) {
               // Why run the display animation?
               return;
            }

            showHover(true, true, true);
         } else {
            m_hoverValid = true;

            // Cancel in-progress calls
            rejectHover();

            // Create a new deferred request
            m_hoverDeferred = $.Deferred();

            // Fetch the html for the click tooltip
            m_options.getHoverHtml(pinData).then(m_hoverDeferred.resolve);

            m_hoverPin = pinData;
            m_bHoverHidden = false;

            showHover(true, true, false);

            // When the deferred object succeeds
            m_hoverDeferred.then(function (strHtml) {
               // Show the click template!!
               m_jHoverTemplate.html(strHtml);

               // Call any initialization JS for the tooltip
               m_options.initHoverTooltip(m_jHoverTemplate, pinData);

               showHover(false, false, true, true);
            });
         }
      };

      self.hideHoverTooltip = function () {
         if (!(!m_bClickHidden && (m_hoverPin === m_clickPin))) {
            m_options.onHideTooltip(m_hoverPin);
            m_options.onHideHoverTooltip(m_hoverPin);
         }
         m_bHoverHidden = true;
         m_jHoverTemplate.stop(true).hide();
         removeCardHover();
         rejectHover();
      };

      /**
       * Hide all open tooltips
       */
      self.clear = function () {
         self.hideHoverTooltip();
         hideClickTooltip();
      };

      self.hideClickTooltip = hideClickTooltip;

      initialize();
   };
});
